import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  user-select: none;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#root {
  height: 1vh
}

input:not([type=checkbox]) {
    user-select: auto;
    display: block;
    padding: 0.375em 0.75em;
    font-size: 1em;
    line-height: 1.42857143;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    -webkit-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;

    &:focus {
      border-color: #66afe9;
      outline: 0;
      -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);
      box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);
    }
  }

  textarea {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1rem; 
    user-select: auto;
    display: block;
    padding: 0.375em 0.75em;
    font-size: 1em;
    line-height: 1.42857143;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    -webkit-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;

    &:focus {
      border-color: #66afe9;
      outline: 0;
      -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);
      box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);
    }
  }

  select {
    word-wrap: normal;
    display: block;
    padding: 0.375em 2.25em 0.375em 0.75em;
    -moz-padding-start: calc(0.75em - 3px);
    font-size: 1em;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: right 0.75em center;
    background-size: 16px 12px;
    border: 1px solid #ced4da;
    border-radius: 0.25em;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  }

  a {
    color: blue;
    text-decoration: none;
    font-weight: bold;

    @media (hover: hover) {
      &:hover {
        color: rgb(10, 10, 255);
      }
    }
  }

  button {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid transparent;
    padding: 0.375em 0.75em;
    font-size: 1em;
    line-height: 1.5;
    border-radius: 0.25em;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    color: #212529;
    background-color: #f8f9fa;
    border-color: #dae0e5;
    align-self: center;
    
    @media (hover: hover) {
      &:hover {
        color: #212529;
        background-color: #e2e6ea;
        border-color: #dae0e5;
        cursor: pointer;
      }
    }

    &.primary {
      color: #fff;
      background-color: #007bff;
      border-color: #007bff;

      @media (hover: hover) {
        &:hover {
          color: #fff;
          background-color: #0069d9;
          border-color: #0062cc;
        }
      }
    }

    &.danger {
      color: white;
      background-color: red;
      border-color: red;

      @media (hover: hover) {
        &:hover {
          color: #fff;
          background-color: #0069d9;
          border-color: #0062cc;
        }
      }
    }

    &:disabled {
      color: black;
      background-color: #fafafa;
      border-color: black;
      
      @media (hover: hover) {
        &:hover {
          color: black;
          background-color: #fafafa;
          border-color: black;
          cursor: not-allowed;
        }
      }
    }
  }

  .error {
      color: red;
      border-color: rgb(255, 50,50);
      -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(1255, 50,50.6);
      box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(255, 50,50.6);
      &::placeholder {
        color: red;
      }
    }
`

export default GlobalStyle;